import {
  CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST,
  CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS,
  CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE,

  CORE_LOAD_HOTDESK_ROLE_REQUEST,
  CORE_LOAD_HOTDESK_ROLE_SUCCESS,
  CORE_LOAD_HOTDESK_ROLE_FAILURE,
} from '../../types'

const requestState = 'request'
  , initialState = []
  , initialStateObj = {}
export default {
  allHotdeskRole: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST:
        return requestState
      case CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE:
        return initialState
      default:
        return state
    }
  },
  hotdeskRoleInfo: (state = initialStateObj, action) => {
    switch (action.type) {
      case CORE_LOAD_HOTDESK_ROLE_REQUEST:
        return requestState
      case CORE_LOAD_HOTDESK_ROLE_SUCCESS:
        let result = null
        if (action.payload && !Array.isArray(action.payload) && typeof action.payload === 'object') {
          result = action.payload
        }
        return result
      case CORE_LOAD_HOTDESK_ROLE_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/hotdeskRole/reducer.js